export const MAGIC_LINK_CALLBACK_URL =
  'https://web.landa.app/redirect?url=magic-link?app=landa';

export const LANDA_FINANCING_TICKER = 'LANDA_FINANCING';
